import React, {Fragment, useState} from 'react'
import {Box, ClickAwayListener, FormControlLabel, ListItem, Popover, Switch, Typography, useTheme} from "@mui/material";
import SvgCustomIcon from "../icons/SvgCustomIcon";
import {Button} from "@mui/material/";
import {Trans} from "@lingui/macro";

const CommunityMapButton = React.memo(({communitySwitches,setCommunitySwitches}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const theme = useTheme()

    const handleButtonClick = (event) => {
        setAnchorEl(anchorEl ? null : event.currentTarget);
    };

    const handleClose = () => setAnchorEl(null);

    const open = Boolean(anchorEl);
    const id = open ? 'community-button-popover' : undefined;

    return (
        <Box position="absolute" bottom="225px" right="9px">
            <Button
                aria-describedby={id}

                onClick={handleButtonClick}
                sx={{
                    backgroundColor: 'white',
                    borderRadius: 0,
                    width: 30,
                    height: 30,
                    boxShadow: 1,
                    border: '1px solid #ccc',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minWidth: 0,
                    padding: 0,
                    '&:hover': {
                        backgroundColor: '#f5f5f5',
                    },
                }}
            >
                {/*<People style={{color: '#333333'}} />*/}
                <SvgCustomIcon name={'twoPerson'} color={'#425B61'} size={20}/>
            </Button>

            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                disableAutoFocus
                disableEnforceFocus
                disableRestoreFocus
                disablePortal={true}
                container={anchorEl}
            >
                <ClickAwayListener
                    onClickAway={(event) => {
                        if (
                            anchorEl &&
                            (anchorEl.contains(event.target) ||
                                document.getElementById('community-popover-box')?.contains(event.target))
                        ) {
                            return;
                        }
                        handleClose();
                    }}
                >
                    <Box
                        id="community-popover-box"
                        sx={{
                            position: 'relative',
                            padding: 2,
                            backgroundColor: theme.palette.mode === 'light' ? 'white' : 'black',
                            borderRadius: 2,
                            boxShadow: 1,
                            minWidth: 250,
                        }}
                        onClick={(e) => e.stopPropagation()}
                    >

                        <Typography
                            sx={{
                                fontSize: 16,
                                fontWeight: 700,
                                textAlign: 'center',
                                mb: 2,
                                color:theme.palette.mode === 'light' ? 'black' : 'white',
                                borderBottom: '1px solid #ddd',
                                pb: 1,
                            }}
                        >
                            <Trans>Community</Trans>
                        </Typography>

                        {communitySwitches.map((elem, index) => (
                            <Fragment key={index}>
                                <ListItem sx={{ pl: 4 }}>
                                    <FormControlLabel
                                        sx={{
                                            '& .MuiFormControlLabel-label': {
                                                fontSize: '14px',
                                                color:theme.palette.mode === 'light' ? 'black' : 'white'
                                            },
                                        }}
                                        checked={elem.checked}
                                        control={<Switch />}
                                        label={elem.label}
                                        onChange={(e) => {
                                            const c = [...communitySwitches];
                                            c[index].checked = !c[index].checked;
                                            setCommunitySwitches(c);
                                            elem.action(e.target.checked);
                                        }}
                                    />
                                </ListItem>
                            </Fragment>
                        ))}
                    </Box>
                </ClickAwayListener>
            </Popover>
        </Box>
    );
})
export default CommunityMapButton;